












































































































import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
import ClassChange from '@/components/ClassChange/index.vue'
import { drinkInfoStatic, exportDrinkData } from '@/api/health/healthStatic'

@Component({
  name: 'drinkWater',
  components: {
    Chart,
    ClassChange
  }
})
export default class extends Vue {
  private classChecked: any = { campusId: '', classroomId: '' }
  private staticTime: string[] = [Date.now() + '', Date.now() + '']
  private staticForm: any = {
    fromTime: '',
    toTime: ''
  }
  private checkStatusOptions: any = {
    title: {
      text: '',
      subtext: '数量(人)',
      top: '35%',
      left: '50%',
      textAlign: 'center',
      textStyle: {
        fontSize: '20'
      }
    },
    color: ['#FE5578', '#6C5CE7', '#1875F0', '#1CD1A1'],
    tooltip: {
      trigger: 'item',
      formatter(item: any) {
        let content = ''
        content = item.name + ':' + ' ' + item.value + '人'
        return content
      }
    },
    legend: {
      orient: 'vertical',
      left: 0,
      bottom: 0,
      formatter: (name: string) => {
        let content = name
        this.checkStatusOptions.series[0].data.map((item: any) => {
          if (item.name === name) {
            content = item.name + ' ' + item.value + '人 '
            if (
              this.checkStatusOptions.title.text &&
              this.checkStatusOptions.title.text > 0
            ) {
              content +=
                (
                  (item.value / this.checkStatusOptions.title.text) *
                  100
                ).toFixed(2) + '%'
            }
          }
        })
        return content
      }
    },
    series: [
      {
        type: 'pie',
        radius: ['45%', '60%'],
        center: ['50%', '40%'],
        avoidLabelOverlap: false,
        label: {
          normal: {
            show: false,
            position: 'center',
            color: '#f00'
          }
        },
        labelLine: {
          normal: {
            show: true
          }
        },
        data: []
      }
    ]
  }
  private standardOptions: any = {
    title: {
      text: '',
      subtext: '',
      top: '35%',
      left: '50%',
      textAlign: 'center',
      textStyle: {
        fontSize: '20'
      }
    },
    color: ['#FE5578', '#6C5CE7', '#1875F0', '#1CD1A1'],
    tooltip: {
      trigger: 'item',
      formatter(item: any) {
        let content = ''
        content = item.name + ':' + ' ' + item.value + '人'
        return content
      }
    },
    legend: {
      orient: 'vertical',
      left: 0,
      bottom: 0,
      formatter: (name: string) => {
        let content = name
        this.standardOptions.series[0].data.map((item: any) => {
          if (item.name === name) {
            content = item.name + ' ' + item.value + '人 '
            if (
              this.checkStatusOptions.title.text &&
              this.checkStatusOptions.title.text > 0
            ) {
              content +=
                (
                  (item.value / this.checkStatusOptions.title.text) *
                  100
                ).toFixed(2) + '%'
            }
          }
        })
        return content
      }
    },
    series: [
      {
        type: 'pie',
        radius: ['45%', '60%'],
        center: ['50%', '40%'],
        avoidLabelOverlap: false,
        label: {
          normal: {
            show: false,
            position: 'center',
            color: '#f00'
          }
        },
        labelLine: {
          normal: {
            show: true
          }
        },
        data: []
      }
    ]
  }
  private averageOptions: any = {
    title: {
      text: '',
      subtext: '平均饮水量(ml)',
      top: '35%',
      left: '50%',
      textAlign: 'center',
      textStyle: {
        fontSize: '20'
      }
    },
    color: ['#FE5578', '#6C5CE7'],
    tooltip: {
      trigger: 'item',
      formatter(item: any) {
        let content = ''
        content = item.name + ':' + ' ' + item.value + '人'
        return content
      }
    },
    legend: {
      orient: 'vertical',
      left: 0,
      bottom: 0,
      formatter: (name: string) => {
        let content = ''
        this.averageOptions.series[0].data.map((item: any) => {
          if (item.name === name) {
            content = item.name + ' ' + item.value + '人 '
            if (
              this.checkStatusOptions.title.text &&
              this.checkStatusOptions.title.text > 0
            ) {
              content +=
                (
                  (item.value / this.checkStatusOptions.title.text) *
                  100
                ).toFixed(2) + '%'
            }
          }
        })
        return content
      }
    },
    series: [
      {
        type: 'pie',
        radius: ['45%', '60%'],
        center: ['50%', '40%'],
        avoidLabelOverlap: false,
        label: {
          normal: {
            show: false,
            position: 'center',
            color: '#f00'
          }
        },
        labelLine: {
          normal: {
            show: true
          }
        },
        data: []
      }
    ]
  }
  private detailForm: any = {
    statisticalTime: Date.now(),
    studentName: '',
    standard: ''
  }

  @Watch('staticTime', { immediate: true, deep: true })
  onChangeValue(newVal: string[], oldValue: string[]) {
    this.staticForm.fromTime = newVal.length ? newVal[0] : ''
    this.staticForm.toTime = newVal.length ? newVal[1] : ''
  }
  mounted() {
    this.getDrinkStaticInfo()
  }
  /**
   * 获取饮水统计图标数据
   */
  private getDrinkStaticInfo() {
    drinkInfoStatic({
      ...this.staticForm,
      classroomId: this.classChecked.classroomId,
      campusId: this.classChecked.campusId
    })
      .then((res) => {
        this.checkStatusOptions.title.text = res.data.studentNum || 0
        this.checkStatusOptions.series[0].data = [
          { name: '已饮水', value: res.data.yetDrinkNum || 0 },
          { name: '未饮水', value: res.data.notDrinkNum || 0 }
        ]
        ;(this.$refs.drinkWaterChart as any).setOption(this.checkStatusOptions)
        if (this.classChecked.classroomId) {
          this.standardOptions.title.text = res.data.drinkNumDay || 0
          this.standardOptions.title.subtext = '饮水标准(杯)'
        } else {
          this.standardOptions.title.text = ''
          this.standardOptions.title.subtext = ''
        }
        this.standardOptions.series[0].data = [
          { name: '达标', value: res.data.standardNum || 0 },
          { name: '未达标', value: res.data.notStandardNum || 0 }
        ]
        ;(this.$refs.standardChart as any).setOption(this.standardOptions)

        this.averageOptions.title.text = res.data.averageDrinkCapacity || 0
        this.averageOptions.series[0].data = [
          {
            name: (res.data.averageDrinkCapacity || 0) + 'ml以上',
            value: res.data.overAverageNum || 0
          },
          {
            name: (res.data.averageDrinkCapacity || 0) + 'ml以下',
            value: res.data.downAverageNum || 0
          }
        ]
        ;(this.$refs.averageChart as any).setOption(this.averageOptions)
      })
      .catch(() => {})
  }

  /**
   * 导出详细数据
   */
  private exportData() {
    let promise = null
    promise = exportDrinkData({
      ...this.detailForm,
      classroomId: this.classChecked.classroomId,
      campusId: this.classChecked.campusId
    })
      .then((res) => {
        window.location.href = (res as any).message
      })
      .catch(() => {})
    return promise
  }

  /**
   * 详细数据查询
   */
  private detailSearch() {
    (this.$refs.table as any).search()
  }

  /**
   * 详细数据重置
   */
  private detailReset() {
    this.detailForm.statisticalTime = Date.now()
    this.detailForm.studentName = ''
    this.detailForm.standard = ''
    this.$nextTick(() => {
      (this.$refs.table as any).fetchData({ page: 1 })
    })
  }

  /**
   * 切换班级
   */
  private classChange() {
    this.getDrinkStaticInfo()
    ;(this.$refs.table as any).fetchData({ page: 1 })
  }
}
